import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { useOpened, UseOpenedReturnValue } from '../useOpened/useOpened';
import { useRefWithCurrentValue } from '../useRefWithCurrentValue';
export function useModalOpened(options) {
  const $ = _c(12);
  const optionsRef = useRefWithCurrentValue(options);
  const {
    opened,
    setOpened,
    close,
    open
  } = useOpened();
  let t0;
  if ($[0] !== close || $[1] !== optionsRef) {
    t0 = () => {
      if (optionsRef.current.closeOnBackDropClick !== false) {
        close();
      }
    };
    $[0] = close;
    $[1] = optionsRef;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleBackdropClick = t0;
  let t1;
  if ($[3] !== handleBackdropClick || $[4] !== opened) {
    t1 = {
      opened,
      onBackdropClick: handleBackdropClick
    };
    $[3] = handleBackdropClick;
    $[4] = opened;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== close || $[7] !== open || $[8] !== opened || $[9] !== setOpened || $[10] !== t1) {
    t2 = {
      opened,
      setOpened,
      close,
      open,
      modalProps: t1
    };
    $[6] = close;
    $[7] = open;
    $[8] = opened;
    $[9] = setOpened;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}
export type UseModalOpenedOptions = {
  /** default: true */
  closeOnBackDropClick?: boolean;
};
export type UseModalOpenedReturnValue = UseOpenedReturnValue & {
  modalProps: ModalProps;
};
export type ModalProps = {
  opened: boolean;
  onBackdropClick: () => void;
};